import { useRouter } from '@bprogress/next/app';
import { useSelector } from '@xstate/store/react';
import { usePathname } from 'next/navigation';
import { useTranslations } from 'next-intl';

import { ProductStockStatus } from '@/fo/api/magento';
import {
  storeProduct,
  cartActions,
  selectCountProductInCart,
  selectCartItemLoading
} from '@/fo/store/product';
import { UiKitButtonBase } from '@/fo/ui/kit/button/base';
import { utilEventProductSubscribeModal } from '@/fo/util/event-product-subscribe-modal';
import { MappedProduct } from '@/fo/util/map-product-data';

import { styles } from './Actions.styles';

interface ActionsProps {
  product: MappedProduct;
  parentSku?: string;
  isAuthorized: boolean;
}

export function Actions({ product }: ActionsProps) {
  const slots = styles();
  const t = useTranslations();
  const router = useRouter();
  const pathname = usePathname();
  const cartCount = useSelector(
    storeProduct,
    selectCountProductInCart(product.sku)
  );
  const cartLoading = useSelector(
    storeProduct,
    selectCartItemLoading(product.sku)
  );

  const isInCart = cartCount > 0;

  const onCartClick = () => {
    if (product.stockStatus === ProductStockStatus.OutOfStock) {
      utilEventProductSubscribeModal.open(product.mindboxId);
      return;
    }

    if (isInCart) {
      router.push('/cart');
    } else {
      cartActions.addProductsToCart([
        {
          sku: product.sku,
          quantity: 1,
          product
        }
      ]);

      if (
        pathname === '/product/besprovodnoy-pylesos-dreame-r10s-essential-aqua/'
      ) {
        const img = new Image();

        img.src =
          'https://ad.new-programmatic.com/conv?aid=12479&convid=10931&random=##RANDOM=##';
      }
    }
  };
  return (
    <div className={slots.base()}>
      <UiKitButtonBase
        className={slots.addToCart()}
        onClick={onCartClick}
        loading={cartLoading && cartCount === 0}
        disabled={product.stockStatus === 'OUT_OF_STOCK'}
      >
        {product.stockStatus === 'OUT_OF_STOCK' && t('Out of stock')}
        {product.stockStatus === 'IN_STOCK' && cartCount > 0 && t('In cart')}
        {product.stockStatus === 'IN_STOCK' &&
          cartCount === 0 &&
          t('Add To Cart')}
      </UiKitButtonBase>
    </div>
  );
}
